import BuildIcon from '@mui/icons-material/Build'
import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import classNames from 'classnames'
import { Button } from 'ui'

import style from './ServiceCenterHeader.module.scss'

type ServiceCenterHeaderProps = {
  link?: string
  handleClick?: () => void
  className?: string
}
// шапка на общей странице сервисный центров
export function ServiceCenterHeader({
  link,
  handleClick,
  className,
}: ServiceCenterHeaderProps) {
  return (
    <div className={classNames(style.userAddressHeader, className)}>
      <h1 className={style.serviceTitle}>
        <BuildIcon />
        Сервисные центры
      </h1>
      {link?.length ? (
        <Button
          // @ts-ignore
          to={link}
          variant='text'
          className={style.backButton}
          onClick={handleClick}
          data-testid='sc-back-btn'
        >
          <Arrow className='rotate180' />
          Назад
        </Button>
      ) : (
        <Button
          variant='text'
          className={style.backButton}
          onClick={handleClick}
          data-testid='sc-back-btn'
        >
          <Arrow className='rotate180' />
          Назад
        </Button>
      )}
    </div>
  )
}
